export default __webpack_public_path__ + "static/media/icn-search.d2e10554.svg";